import { vehicleLabel } from '@/lib/ride-format';
import type { RideDriver, RideVehicle } from '@/lib/rides-types';
import { Icon } from '@/components/ui/icon';

/**
 * Driver + vehicle details. These arrive after assignment (on_status / on_update),
 * so until then it shows a "finding your driver" placeholder.
 */
export function DriverVehicleCard({
  driver,
  vehicle,
}: {
  driver?: RideDriver;
  vehicle?: RideVehicle;
}) {
  if (!driver && !vehicle) {
    return (
      <div className="wb-card wb-card--pad wb-row wb-gap-12 wb-small">
        <span className="wb-skel" style={{ width: 40, height: 40, borderRadius: 999 }} />
        Finding your driver…
      </div>
    );
  }

  const vehicleName =
    [vehicle?.make, vehicle?.model].filter(Boolean).join(' ') ||
    vehicleLabel(vehicle?.category, vehicle?.variant);
  const vehicleMeta = [vehicle?.registration, vehicleLabel(vehicle?.category, vehicle?.variant)]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="wb-card wb-card--pad wb-col wb-gap-12">
      {driver && (
        <div className="wb-row wb-between wb-gap-12">
          <div>
            <p className="wb-strong" style={{ color: 'var(--ink)' }}>
              {driver.name || 'Your driver'}
            </p>
            {driver.rating && (
              <p className="wb-tiny wb-row wb-gap-4">
                <Icon name="starFill" size={12} style={{ color: 'var(--honey)' }} /> {driver.rating}
              </p>
            )}
          </div>
          {driver.phone && (
            <a
              href={`tel:${driver.phone}`}
              className="wb-btn wb-btn--secondary wb-btn--sm"
              style={{ flexShrink: 0 }}
            >
              <Icon name="phone" size={18} /> Call
            </a>
          )}
        </div>
      )}
      {vehicle && (
        <div style={driver ? { borderTop: '1px solid var(--line)', paddingTop: 12 } : undefined}>
          <p className="wb-strong" style={{ color: 'var(--ink)' }}>
            {vehicleName}
          </p>
          {vehicleMeta && <p className="wb-small">{vehicleMeta}</p>}
        </div>
      )}
    </div>
  );
}
